export default "__VITE_ASSET__dDPg0YX8__"